export const INITIALIZE = 'INITIALIZE';
export const TOGGLE_SUBSCRIPTION = 'TOGGLE_SUBSCRIPTION';
export const SAVING_SUBSCRIPTION = 'SAVED_SUBSCRIPTION';
export const UPDATED_SUBSCRIPTION = 'UPDATED_SUBSCRIPTION';